<template>
  <!-- :style="boxSize" -->
  <div
    class="wrapper"
    ref="scroller"
    @contextmenu.prevent="openMenu1"
    style="color: #eaf5eb"
  >
    <div v-if="historyLoding" @click="$emit('loadHistory')">
      {{ historyConfig.tip }}
    </div>
  
    <div class="scroller">
      <div class="web__main" ref="main">
        <div
          class="web__main-item"
          v-for="(item, index) in source === 0 ? saveList : list"
          :key="index"
          :style="{ paddingLeft: item.type === '1' ? '0' : '54px' }"
          :class="{ 'web__main-item--mine': item.mine }"
        >
          <div v-if="item.type === '0'">
            <div class="web__main-user">
              <img
                v-if="item.mine"
                :src="item.avar"
                @click="bindClick('avar', item)"
              />
              <!-- 访客头像 -->
              <img
                v-if="!item.mine"
                :src="defaultAvatar"
                @click="bindClick('avar', item)"
              />

              <cite @click="bindClick('nickname', item)" class="nick_container">
                {{ item.name }}
                <i class="date_container">{{ item.date }}</i>
              </cite>
            </div>
            <i
              class="el-icon-warning"
              v-show="item.icon && item.mine"
              style="
                font-size: 14px;
                color: red;
                margin-top: 40px;
                margin-right: 5px;
              "
            ></i>
            <div
              style="
                display: flex;
                align-items: center;
                padding-top: 20px;
                justify-content: flex-end;
              "
              :style="{ 'flex-direction': item.mine ? 'row' : 'row-reverse' }"
            >
              <el-radio
                v-model="item.isChecked"
                class="deepRadio"
                label="1"
                v-if="feedbackIsShow"
                @click.native.prevent="handleRadioClick(index, item.isChecked)"
                style="left: -22px"
              ></el-radio>
              <img
                src="../../../static/talks/msgError.png"
                alt=""
                width="20px"
                height="20px"
                v-if="item.sendStatus === 2"
              />
              <div
                class="web__main-text"
                @contextmenu.prevent.stop="openMenu2"
                :class="{
                  'web__main-text1': item.color == '1',
                  'web__main-text2': item.color == '2',
                  'web__main-text3':
                    item.color !== 1 &&
                    item.color !== 2 &&
                    item.name === '小贝',
                }"
              >
                <itemTalk
                  v-if="item.text.text"
                  @getChildText="getChildText"
                  :text="item.text.text"
                  :type="item.type"
                  :mine="item.mine"
                  :name="item.name"
                />
              </div>
            </div>
            <span class="readedMsg" v-if="item.status && item.status === 1">
              已读
            </span>
          </div>

          <div v-else-if="item.type === '1'">
            <div
              class="web__main-text web_main-systip"
              @contextmenu.prevent.stop="openMenu2"
            >
              <span style="font-weight: 400; color: #aaaaaa"
                >{{ item.date }}-[提示]-</span
              >
              <span style="font-weight: 400; color: #f85a5a">{{
                item.text.text
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="downBtn" v-if="!isBottom" @click="scrollBottom">
			<span v-if="unread">{{unread}}</span>
		</div> -->
    <!-- <ul class="contextmenu" v-show="showMenu" :style="{left:left+'px',top:top+'px',width:'auto',zIndex:'99',height:'auto'}">
			<li style="height: 1.25rem;width: 3.75rem;">上移</li>
			<li style="height: 1.25rem;width: 3.75rem;">下移</li>
			<li style="height: 1.25rem;width: 3.75rem;">标签</li>
		</ul> -->

    <div
      class="contextmenu"
      v-show="menuVisible"
      :style="{ border: menuType == 1 && source === 0 ? 'none' : '' }"
    >
      <div
        class="contextmenu__item"
        v-show="menuType == 1"
        v-clipboard:copy="allText"
        v-clipboard:success="allTextCopy2"
        v-clipboard:error="onError"
      >
        全文复制
      </div>
      <div
        class="contextmenu__item"
        v-show="menuType == 2"
        v-clipboard:copy="copyText"
        v-clipboard:success="allTextCopy"
        v-clipboard:error="onError"
      >
        复制
      </div>
      <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        @click="updateMark"
      >
        备注
      </div>
      <!-- <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        @click="transformText"
      >
        翻译
      </div> -->
      <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        v-for="(item, index) in menuList"
        :key="index"
        @click="clickMenu(item)"
      >
        {{ item.name }}
      </div>
      <div
        class="contextmenu__item"
        v-show="menuType == 2 && source === 0"
        @click="handleFeedback"
        v-if="isNaN(Number(keyInfo.aduserId)) && keyInfo.aduserId !== ''"
      >
        反馈
      </div>
      <!-- v-if="isNaN(Number(keyInfo.aduserId)) && keyInfo.aduserId !== ''" -->

      <!-- <div class="contextmenu__item" v-show="menuType==2" @click="getWeChat(2)">转微</div>
			<div class="contextmenu__item" v-show="menuType==2" @click="getTel(2)">转电</div> -->
      <!-- <div class="contextmenu__item" v-show="menuType==2" @click="getQQ(2)">转QQ</div> -->
    </div>

    <el-dialog
      title="备注"
      :visible.sync="isShowMark"
      width="40%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input
        type="textarea"
        v-model="inputMark"
        placeholder="请输入备注"
        style="width: 100%"
        maxlength="40"
        show-word-limit
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowMark = false">取 消</el-button>
        <el-button type="primary" @click="updateMarkRequest">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Scroll from "@/utils/scroll";
import itemTalk from "./itemTalk";

export default {
  name: "JwChat_list",
  components: {
    itemTalk,
  },
  filters: {
    setWidth(value) {
      let width = value;
      if (`${value}`.match(/^\d+$/)) {
        width = value + "px";
      }
      return width;
    },
  },
  props: {
    pageConfig: {
      type: Object,
      default: () => ({
        width: "100vw",
      }),
    },
    list: {
      type: Array,
      default: () => [],
    },
    feedback: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: () => ({
        width: "667px",
        height: "382px",
      }),
    },
    source: {
      type: Number,
      default: () => 0,
    },
    user: {},
    keyInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      load: false,
      scroll: null,
      scrollTimer: null,
      beforeTitle: "",
      titleTimer: "",
      loadHistory: false,
      historyLoding: false,
      // 快捷菜单
      menuVisible: false,
      top: 0,
      left: 0,
      menuType: 1,
      // 备注
      isShowMark: false,
      inputMark: "",
      allText: "",
      dataText: "",
      userInfo: {},
      userData: {},
      menuList: null,
      copyText: "",
      selectedText: "",
      saveList: [],
      feedbackIsShow: false,
      defaultAvatar: "",
    };
  },

  watch: {
    load(newval) {
      console.log("监听消息load", newval);
    },
    list: {
      handler(newval) {
        if (newval) {
          this.saveList = JSON.parse(JSON.stringify(newval));
          console.log("saveList:=====", this.saveList);
          // this.scrollBottom();
          this.feedbackIsShow = false;
          this.$nextTick(() => {
            setTimeout(() => {
              console.log("1111", this.saveList);
              console.log("this.scrollType ====", this.scrollType);
              let reset = false;
              if (this.historyLoding) {
                reset = true;
                this.closeTopTip();
                this.$nextTick(() => {
                  this.scroll.toBeforePosition();
                });
              }
              this.load = true;
              console.log("reset:", reset);
              this.childnodeLoad();
              console.log();
              if (this.$parent.isScolTop) {
                console.log("查看历史信息");
                this.scroll.scrollTo(0, 0, 200);
              } else {
                if (this.source === 0) {
                  console.log("不查看历史信息");
                  //this.scroll.scrollTo(0, this.scroll.maxScrollY, 200);
                }
              }
              if (reset) {
                this.scroll.resetTop();
              }
              //去掉滚到到底部
              if (this.scrollType === "scroll") {
                console.log("lallalll scrollBottom");
                this.scrollBottom();
              }
            }, 300);
          });
        }
      },
      deep: true,
    },
    // list(newval) {
    //   if (newval) {
    //     this.saveList = JSON.parse(JSON.stringify(newval));
    //     console.log("saveList:=====", this.saveList);
    //     // this.scrollBottom();
    //     this.feedbackIsShow = false;
    //     this.$nextTick(() => {
    //       console.log("-------------", this.saveList);
    //       setTimeout(() => {
    //         let reset = false;
    //         if (this.historyLoding) {
    //           reset = true;
    //           this.closeTopTip();
    //           this.$nextTick(() => {
    //             this.scroll.toBeforePosition();
    //           });
    //         }
    //         this.load = true;
    //         console.log("reset:", reset);
    //         this.childnodeLoad();
    //         console.log();
    //         if (this.$parent.isScolTop) {
    //           console.log("查看历史信息");
    //           this.scroll.scrollTo(0, 0, 200);
    //         } else {
    //           if (this.source === 0) {
    //             console.log("不查看历史信息");
    //             this.scroll.scrollTo(0, this.scroll.maxScrollY, 200);
    //           }
    //         }
    //         if (reset) {
    //           this.scroll.resetTop();
    //         }
    //         if (this.scrollType === "scroll") {
    //           this.scrollBottom();
    //         }
    //       }, 300);
    //     });
    //   }
    // },
    feedback(newVal) {
      this.feedbackIsShow = newVal;
      this.saveList = JSON.parse(JSON.stringify(this.list));
      if (this.feedback === false) {
        console.log(this.saveList);
        console.log(this.list);
        this.$emit("sendList", this.saveList);
      }
    },
    feedbackIsShow() {
      this.$emit("getFeedbackState", this.feedbackIsShow);
    },
    "config.scrollToButton"(newval) {
      if (newval) {
        console.log("config.scrollToButton")
        this.scrollBottom();
      }
    },
    unread(newval) {
      if (newval) {
        this.beforeTitle && this.resetTitle(this.beforeTitle);
        // this.saveTitle()
        // this.changeTitle()
        this.showBrowser();
      } else {
        // this.resetTitle(this.beforeTitle)
        this.resetTitle("智能客服");
      }
    },
    menuVisible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },

    autoTransfer(newVal, oldVal) {
      console.log("chatList watch autoTransfer00 newVal = ", newVal);
      console.log("chatList watch autoTransfer oldVal = ", oldVal);
      for (var i = 0; i < this.list.length; i++) {
        var chat = this.list[i];
        if (!chat.mine && chat.type === "0") {
          if (chat.text.text === newVal.message) {
            chat.color = "1";
          }
        }
      }

      this.dataText = newVal.content;
      if (newVal.type == 2) {
        this.getTel(1);
      } else if (newVal.type == 3) {
        this.getWeChat(1);
      } else if (newVal.type == 4) {
        this.getQQ(1);
      }
    },
    user(newVal, oldVal) {
      console.log("chatList watch user new = ", newVal);
      console.log("chatList watch user old = ", oldVal);
      this.userInfo = newVal;
    },
  },
  destroyed() {},
  computed: {
    boxSize() {
      let { height = "382px", width = "667px" } = this.config || {};
      if (`${height}`.match(/\d$/)) {
        height += "px";
      }
      if (`${width}`.match(/\d$/)) {
        width += "px";
      }
      const style = {
        height,
        width,
      };
      return style;
    },

    historyConfig() {
      const { historyConfig: { tip = "", activate = false } = {} } =
        this.config;
      return {
        tip,
        activate,
      };
    },
    isBottom() {
      return this.scroll && this.scroll.isBottom;
    },
    scrollType() {
      const { scrollType: type = "noroll" } = this.config;
      return type;
    },
    unread() {
      const { unread = 0 } = this.scroll || {};
      return unread;
    },

    autoTransfer() {
      console.log(
        "chatList computed autoTransfer",
        this.$store.state.iAutoChange
      );
      return this.$store.state.iAutoChange;
    },
  },

  methods: {
    //默认头像
    async getDefaultAvatar() {
      var api = "/manager/sysconf/getCustDefaultPortrait";
      var res = await this.util.postRequest({
        url: api,
        data: {},
      });

      if (res.resultCode === "10000") {
        console.log("res getDefaultAvatar--", res.data);
        this.defaultAvatar = res.data;
      } else {
        this.$message.error(res.desc);
      }
    },
    handleRadioClick(index, item) {
      if (item === "0") {
        this.saveList[index].isChecked = "1";
      } else {
        this.saveList[index].isChecked = "0";
      }
      console.log("this.list[index].isChecked:", this.list[index].isChecked);
      this.$emit("sendList", this.saveList);
    },
    // 获取itemTalk组件传递的数据
    getChildText(data) {
      this.selectedText = data;
      console.log("子组件数据", data);
      console.log("选中的文字", this.selectedText);
    },
    scrollBottom() {
      console.log("scrollBottom", this.source);
      if (this.scroll) {
        this.scroll.refresh();
        setTimeout(() => {
          this.scroll.scrollTo(0, 0, 200);
          if (this.source !== 1) {
            this.scroll.scrollTo(0, this.scroll.maxScrollY, 200);
          } else {
            this.scroll.scrollTo(0, 0, 200);
          }
        }, 400);
      }
    },
    bindClick(type, data) {
      this.$emit("click", {
        type,
        data,
      });
    },
    createScroll() {
      // const that = this
      const dom = this.$refs.scroller;
      this.scroll = new Scroll(dom, {
        click: true,
        scrollbars: true,
        mouseWheel: true,
        preventDefault: false,
        interactiveScrollbars: true,
        hijackInternalLinks: true,
        // useTransform: false,
      });
      console.log("this.scroll", this.scroll);
      // copy code
      // dom.addEventListener(('ontouchstart' in window) ? 'touchstart' : 'mousedown', function(e) {
      // 	e.stopPropagation();
      // 	var target = e.target;
      // 	while (target.nodeType != 1) target = target.parentNode;
      // 	if (target.tagName === "SPAN") {
      // 		var clipBoardContent = target.innerText;
      // 		if (!clipBoardContent) return;
      // 		const input = document.createElement('input');
      // 		document.body.appendChild(input);
      // 		input.setAttribute('value', clipBoardContent);
      // 		input.select();
      // 		if (document.execCommand('copy')) {
      // 			document.execCommand('copy');
      // 			that.$message({
      // 				message: '复制成功',
      // 				type: 'success'
      // 			});
      // 		}
      // 		document.body.removeChild(input);
      // 	}
      // })

      // scroll done callback
      // this.scroll.on('scrollStart', function() {
      // 	console.log('chatList scroll on 11111')
      // 	// console.log('scroll')
      // 	that.scrollTop()
      // 	// that.scrollBottom()
      // 	if (that.historyLoding) return
      // 	console.log('chatList scroll on 2222')
      // 	that.scroll.savePosition()
      // 	that.scroll.read()
      // });
    },
    scrollTop() {
      const { isTop } = this.scroll;

      if (isTop) {
        if (this.loadHistory) {
          this.historyLoding = true;
        } else this.loadHistory = true;
        return;
      }
      this.closeTopTip();
    },
    closeTopTip() {
      this.loadHistory = false;
      this.historyLoding = false;
    },
    childnodeLoad() {
      if (this.scrollType === "scroll") return;
      const parent = this.$refs.main;
      if (!parent) return;
      // const childs = parent.children
      // console.log('chatList childnodeLoad childs = ', childs)
      // childs.forEach(i => {
      // 	const top = i.offsetTop
      // 	this.scroll.setPosition(top, i)
      // })
    },
    scrollRefresh() {
      setTimeout(() => {
        this.scroll && this.scroll.refresh();
        this.scrollRefresh();
      }, 0);
      return;
    },
    saveTitle() {
      const { title } = document;
      this.beforeTitle = title;
    },
    resetTitle(title) {
      console.log("chatList title = ", title);
      //document.title = title
      document.title = "智能客服";
      clearTimeout(this.titleTimer);
    },
    changeTitle() {
      const that = this;
      // let flage = 0;
      change();

      function change() {
        // let title = "【未读】"
        // if (flage) {
        // 	title = "【" + that.unread + "条】"
        // }
        // flage = !flage
        // that.titleTimer = setTimeout(() => {
        // 	that.resetTitle(title + that.beforeTitle)
        // 	change()
        // }, 1000);

        that.titleTimer = setTimeout(() => {
          that.resetTitle("智能客服");
          change();
        }, 1000);
      }
    },
    showBrowser() {
      // if (window.Notification && Notification.permission !== "denied") {
      // 	const {
      // 		unread
      // 	} = this
      // 	Notification.requestPermission(function(status) {
      // 		if (status === "granted")
      // 			new Notification('新消息', {
      // 				body: `您总共有${unread}条消息未读。`
      // 			});
      // 	});
      // }
    },
    // 快捷菜单方法
    openMenu1(e) {
      // console.log(e.clientX,e.clientY)
      console.log("类型：", this.menuType);

      if (this.source === 0) {
        this.loadAllText(0);
      } else {
        this.loadAllText(1);
      }
      this.menuType = 1;
      this.menuVisible = false;
      this.menuVisible = true;
      var menu = document.querySelector(".contextmenu");
      this.styleMenu(menu, e);
    },
    async openMenu2(e) {
      // 根据鼠标有无选中的值 复制文字
      console.log("keyname = ", this.$store.state.keyName);
      if(this.$store.state.keyName == '已离开' || this.$store.state.keyName == '在线访客列表') return;
      if (this.selectedText !== "") {
        this.copyText = this.selectedText;
      } else {
        this.copyText = e.target.innerText;
      }
      var api = "/manager/label/selectSystemLabelList";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      console.log("chatList openMenu2 response = ", response.data);
      console.log("chatList openMenu2 response = ", response);
      if (response.resultCode === "10000") {
        this.menuList = response.data;
        this.dataText = e.target.innerText;
        this.menuType = 2;
        this.menuVisible = false;
        this.menuVisible = true;
        var menu = document.querySelector(".contextmenu");
        this.styleMenu(menu, e);
      } else {
        this.$message.error(response.desc);
      }
    },
    closeMenu() {
      this.menuVisible = false;
    },

    clickMenu(obj) {
      this.addLabel(obj);
    },

    styleMenu(menu, event) {
      console.log(
        "event.clientX",
        event.clientX,
        "event.clientY",
        event.clientY,
        event
      );
      console.log(this.source);
      if (this.source == 0) {
        menu.style.left =
          event.clientX -
          document.getElementsByClassName("left_container")[0].clientWidth -
          document.getElementsByClassName("menu_div")[0].clientWidth -
          document.getElementsByClassName("mydia_div")[0].clientWidth +
          "px";
        console.log(menu.style.left);
        let topY =
          event.clientY -
          document.getElementsByClassName("header")[0].clientHeight -
          document.getElementsByClassName("header_line")[0].clientHeight -
          100;
        if (this.menuType == 2) {
          if (
            document.getElementsByClassName("chatBox")[0].clientHeight -
              topY -
              document.getElementsByClassName("toolBox")[0].clientHeight <
            351
          ) {
            menu.style.top =
              document.getElementsByClassName("taleBox")[0].clientHeight -
              351 +
              "px";
          } else {
            menu.style.top = topY + "px";
          }
        } else {
          menu.style.top = topY + "px";
        }
        console.log("菜单---：", menu);
        console.log(menu.style.left);
        console.log(menu.style.top);
      }
      if (this.source == 1) {
        var fontSize = parseInt(window.getComputedStyle(event.target).fontSize);
        var sizeY =
          event.clientY -
          document.getElementsByClassName("taleBox")[0].offsetTop -
          3 * fontSize;
        var sizeX =
          event.clientX -
          document.getElementsByClassName("el-drawer__wrapper")[0].offsetLeft;
        // 给右键菜单元素定位
        if (
          sizeX >=
          document.getElementsByClassName("el-drawer__wrapper")[0].offsetWidth -
            menu.offsetWidth
        ) {
          sizeX =
            document.getElementsByClassName("el-drawer__wrapper")[0]
              .offsetWidth - menu.offsetWidth;
        }
        menu.style.left = sizeX + "px";
        menu.style.top = sizeY + "px";
        console.log("menu left", menu.style.left);
        console.log("menu top", menu.style.top);
      }
    },
    async updateMarkRequest() {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }
      var api = "/manager/chat/customer/set/remark";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selected.cid,
          remark: this.inputMark,
          sid: selected.sid,
        },
      });
      if (response.resultCode === "10000") {
        this.config.mark = this.inputMark;
        this.isShowMark = false;
      } else {
        this.$message.error(response.desc);
      }
    },
    allTextCopy(e) {
      console.log("复制", e.text);
      this.$store.state.copyText = e.text;
      // console.log("全文复制")
    },
    allTextCopy2(e) {
      console.log("全文复制2:", e.text);
      this.$store.state.copyText = e.text;
    },
    onError(e) {
      console.log(e);
    },
    transformText() {
      console.log("翻译该条消息");
    },
    updateMark() {
      this.$emit("updateMark", this.dataText);
    },
    handleFeedback() {
      console.log("客服反馈");
      this.feedbackIsShow = true;
    },
    // eslint-disable-next-line no-unused-vars
    addLabel(_obj) {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }
      // 接口调用已移除，直接执行成功后的流程
      // _obj 参数保留以保持接口一致性
      // console.log('1112222')
      // if (this.$store.state.keyName !== '我的同事') {
      // 	// this.$store.dispatch('autoChangeStatus', '2')
      // 	this.$store.state.selectedClient.labels.unshift(obj)
      // 	if (this.$store.state.selectedClient.labels.length > 5) {
      // 		this.$store.state.selectedClient.labels.pop()
      // 	}
      // } else {
      // 	this.$store.state.college.nowSelectClient.labels.unshift(obj)
      // 	if (this.$store.state.college.nowSelectClient.labels.length > 5) {
      // 		this.$store.state.college.nowSelectClient.labels.pop()
      // 	}
      // }
      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getWeChat(i) {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;

        if (i === 1) {
          return;
        }
      }

      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':3,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }
      if (this.$store.state.keyName !== "我的同事") {
        this.$store.dispatch("autoChangeStatus", "2");
      } else {
        if (this.$store.state.college.nowSelectClient.status < 2) {
          this.$store.state.college.nowSelectClient.status = "2";
        }
      }
      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getTel(i) {
      console.log("chatList getTel i = ", i);
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;

        if (i === 1) {
          return;
        }
      }

      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':2,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }
      if (this.$store.state.keyName !== "我的同事") {
        this.$store.dispatch("autoChangeStatus", "2");
      } else {
        if (this.$store.state.college.nowSelectClient.status < 2) {
          this.$store.state.college.nowSelectClient.status = "2";
        }
      }

      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getOrder(itemid) {
      console.log("chatList getOrder itemid = ", itemid);
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }

      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':2,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }

      if (itemid === "weiyuyue") {
        if (this.$store.state.keyName !== "我的同事") {
          this.$store.dispatch("autoChangeStatus", "3");
        } else {
          if (this.$store.state.college.nowSelectClient.status < 3) {
            this.$store.state.college.nowSelectClient.status = "3";
          }
        }
      } else if (itemid === "yuyue") {
        if (this.$store.state.keyName !== "我的同事") {
          this.$store.dispatch("autoChangeStatus", "4");
        } else {
          if (this.$store.state.college.nowSelectClient.status < 4) {
            this.$store.state.college.nowSelectClient.status = "4";
          }
        }
      }

      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },

    getQQ(i) {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;

        if (i === 1) {
          return;
        }
      }
      // const QQReg = /[1-9]([0-9]{5,11})/
      // let QQ = this.dataText.replace(/\s|[(]|[)]|[（]|[）]|[-]*/g, '').match(QQReg)[0]
      
      // 接口调用已移除，直接执行成功后的流程
      // if(i==2){
      // 	this.$store.state.iAutoChange = {
      // 		'type':4,
      // 		'content':this.dataText,
      // 		'message':this.dataText,
      // 		'cid':selected.cid,
      // 		'sid':selected.sid
      // 	}
      // }
      // if (this.$store.state.keyName !== '我的同事') {
      // 	this.$store.dispatch('autoChangeStatus', '2')
      // } else {
      // 	this.$store.state.college.nowSelectClient.status = '2'
      // }

      if (this.$store.state.keyName !== "我的同事") {
        this.$store.dispatch("autoChangeStatus", "2");
      } else {
        if (this.$store.state.college.nowSelectClient.status < 2) {
          this.$store.state.college.nowSelectClient.status = "2";
        }
      }

      setTimeout(() => {
        this.$emit("getDetail");
      }, 500);
    },
    loadAllText(source) {
      if (source === 0) {
        this.getDetailRequest();
      } else {
        this.getAlltext();
      }
    },
    getAlltext() {
      console.log("this.list", this.list);
      this.allText = "";
      if (this.list != null) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].name != "") {
            this.allText =
              this.allText +
              this.list[i].name +
              " " +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          } else {
            this.allText =
              this.allText +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          }
        }
        // console.log(this.allText);
      }
    },
    // 获取用户信息
    async getDetailRequest() {
      let selected = this.$store.state.selectedClient;
      if (!selected) {
        selected = this.$store.state.college.nowSelectClient;
      }
      var api = "/manager/chat/customer/detail";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          cid: selected.cid,
          csid: this.util.getLocalId(),
          sid: selected.sid,
        },
      });
      // console.log("chatList getDetailRequest response = " , response)
      this.userData = response.data;
      this.initAlltext(this.userData);
    },
    initAlltext(userData) {
      this.allText = "";
      // this.allText = "昵称:" + userData.customerNickname
      let nickname =
        userData.customerNickname != null ? userData.customerNickname : "";
      let cid = userData.cid;
      let remark =
        userData.customerRemark != null ? userData.customerRemark : "";
      let keyword = userData.keyword ? userData.keyword : "无";
      let searchword = userData.query ? userData.query : "无";
      let source = userData.source == 1 ? "百度" : "";
      let labels = this.getLabels(userData.lastLabels);
      this.allText =
        "昵称:" +
        nickname +
        "\n" +
        "永久编号:" +
        cid +
        "\n" +
        "备注:" +
        remark +
        "\n" +
        "搜索词：" +
        searchword +
        "\n" +
        "关键词:" +
        keyword +
        "\n" +
        "来源:" +
        source +
        "\n" +
        "标签:" +
        labels +
        "\n";
      console.log("chatList initAlltext ", this.allText);
      if (this.list != null) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].name != "") {
            this.allText =
              this.allText +
              this.list[i].name +
              " " +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          } else {
            this.allText =
              this.allText +
              this.list[i].date +
              " " +
              this.list[i].text.text +
              "\n";
          }
        }
      }
      //   this.$store.state.allText = this.allText;
    },
    getLabels(list) {
      let labels = "";
      if (list != []) {
        for (let i = 0; i < list.length; i++) {
          labels = labels != "" ? labels + " " + list[i].name : list[i].name;
        }
      } else {
        labels = "";
      }
      return labels;
    },
  },
  mounted() {
    this.getDefaultAvatar();
    console.log("首次进入chatList页面", this.defaultAvatar);

    this.scrollRefresh();
    this.createScroll();
  },
};
</script>

<style>
.iScrollVerticalScrollbar.iScrollLoneScrollbar {
  z-index: 1 !important;
}

.feedback {
  display: flex;
  justify-content: center;
}

.web__msg--img,
.web__msg--video,
.web__msg--file {
  position: relative;
  max-width: 250px;
  min-width: 200px;
  width: 100%;
  margin: 10px 0;
  border: 1px solid #eee;
  overflow: scroll;
  border-radius: 5px;
  cursor: pointer;
  display: block;
}

.web__msg--audio-player {
  display: block;
  width: 240px;
  max-width: 100%;
  margin: 8px 0;
  outline: none;
}

.web__msg--voice {
  display: inline-flex;
  align-items: center;
  min-width: 80px;
  max-width: 220px;
  padding: 8px 12px;
  margin: 4px 0;
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.04);

  .voice-icon {
    font-size: 18px;
    margin-right: 8px;
    color: #333;
  }

  .voice-meta {
    display: flex;
    flex-direction: column;
    line-height: 1.3;
  }

  .voice-label {
    font-size: 13px;
    color: #333;
  }

  .voice-duration {
    font-size: 12px;
    color: #888;
  }

  .voice-error {
    font-size: 12px;
    color: #f56c6c;
  }

  &.is-playing .voice-icon {
    color: #07c160;
  }

  &.is-loading {
    opacity: 0.7;
    cursor: wait;
  }
}

/* .web__msg--img,
	.web__msg--video,
	.web__msg--file::-webkit-scrollbar{
		display: none;
	} */

.web__msg--img[data-class="iconBox"] {
  max-width: 24px;
  min-width: unset;
  border: none;
  margin: 0;
  vertical-align: bottom;
  display: inline-block;
}
</style>
<style scoped lang="scss">
.messageBox {
  display: flex;
  justify-content: flex-end;
  justify-items: center;
}

.deepRadio ::v-deep  {
  // position: absolute;
  // top: calc(50% - 7px);
  left: 0 !important;
  margin-right: 0 !important;
  .el-radio__label {
    display: none;
  }

  .el-radio__inner {
    margin-right: 0;
    // background-color: #1577d2;
    border-color: #1577d2;
  }

  .el-radio__input.is-checked .el-radio__inner::after {
    content: "";
    width: 10px;
    height: 5px;
    border: 2px solid white;
    border-top: transparent;
    border-right: transparent;
    text-align: center;
    display: inline-block;
    position: absolute;
    top: 0px;
    left: 0px;
    vertical-align: middle;
    transform: rotate(-45deg);
    border-radius: 0px;
    background: none;
  }
}

.el-dialog__title::before {
  display: block;
  content: "";
  width: 3px;
  height: auto;
  background-color: #1577d2;
  margin-right: 6px;
}

.el-dialog__title {
  display: flex;
  color: #333;
  font-weight: 600;
  line-height: 1;
}

.wrapper :deep() .iScrollVerticalScrollbar.iScrollLoneScrollbar {
  z-index: 1 !important;
}

.downBtn {
  position: absolute;
  cursor: pointer;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  bottom: 2rem;

  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  &::before {
    content: "V";
    position: absolute;
    background: rgba(204, 204, 204, 0.2);
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    border-radius: 50%;
    top: 60%;
    left: 50%;
    transform: translateX(-50%);
  }

  span {
    background: #409eff;
    padding: 0.1rem 0.5rem;
    font-size: 0.7rem;
    border-radius: 0.5rem;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  // height: 28.125rem;
  overflow: hidden;
  // background-color: orange;

  /* Prevent native touch events on Windows */
  -ms-touch-action: none;

  /* Prevent the callout on tap-hold and text selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Prevent text resize on orientation change, useful for web-apps */
  -webkit-text-size-adjust: none;
  -moz-text-size-adjust: none;
  -ms-text-size-adjust: none;
  -o-text-size-adjust: none;
  text-size-adjust: none;
}

.wrapper::-webkit-scrollbar {
  display: none;
}

// .chat_tip {
// 	width: 600px;
// 	height: 84px;
// 	background: rgba(0, 0, 0, 0.05);
// 	border-radius: 4px;
// }

.scroller {
  position: absolute;
  // width: calc(100% - 1.5rem);
  width: 92%;
  padding: 0.3125rem 1.875rem; //上10 右20 下10 左20

  /* Prevent elements to be highlighted on tap */
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  /* Put the scroller into the HW Compositing layer right from the start */
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}

.web__main-item {
  position: relative;
  font-size: 0;
  margin-bottom: 4px;
  padding-left: 54px;
  // max-height: 68px;
  // min-height: 40px;
  text-align: left;
  // background-color: cyan;
}

.web__main-user,
.web__main-text {
  display: inline-block;
  /* @css { * }display: inline;
    @css { * }zoom: 1; */
  vertical-align: top;
  @include change_size($font_size_normal);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333334;
}

.web__main-user {
  position: absolute;
  cursor: pointer;
  left: 3px;
  // background-color: red;
}

.web__main-user img {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 100%;
  transform: scaleX(-1);
}

.web__main-user cite {
  position: absolute;
  // left: 60px;
  top: -2px;
  /* width: 500px; */
  // line-height: 24px;
  font-size: 12px;
  white-space: nowrap;
  // color: #999;
  text-align: left;
  font-style: normal;
  padding-left: 10px;
}

.web__main-user cite i {
  padding-left: 15px;
  font-style: normal;
}

.web__main-text {
  max-width: 75%;
  position: relative;
  // line-height: 1.4;
  line-height:22px;
  // margin-top: 20px;
  // margin-left: 50px;
  padding: 4px 15px;
  // background-color: #f3f3f3;
  // border-radius: 3px;
  // border: 1px solid #f0f0f0;
  color: #5a9cf8;
  word-break: break-all;
  background: #f2f7ff;
  border-radius: 10px;
}

.systip_div {
  background-color: red;
  display: flex;
  flex-direction: column;
}

.web__main-sys {
  max-width: 90%;
  position: relative;
  line-height: 22px;
  // margin-top: 25px;
  padding: 8px 15px;
  color: #5a9cf8;
  word-break: break-all;
  background: #f2f7ff;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.web__main-arrow {
  top: 6px;
  left: -8px;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 8px;
  border-left-width: 0;
  border-right-color: #ebeef5;
}

.web__main-arrow::after {
  content: " ";
  top: -7px;
  left: 1px;
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: 7px;
  border-left-width: 0;
  border-right-color: #ebeef5;
}

.web__main-item--mine .web__main-text .web__main-arrow {
  left: auto;
  right: -5px;
  border-color: transparent;
  border-style: solid;
  border-width: 8px;
  border-right-width: 0;
  border-left-color: #409eff;
}

.web__main-item--mine .web__main-text .web__main-arrow::after {
  left: auto;
  right: -2px;
  border-color: transparent;
  border-style: solid;
  border-width: 7px;
  border-right-width: 0;
  border-left-color: #409eff;
}

.web__main-list {
  margin: 10px 0;
}

.web__main-list li {
  height: 30px;
  color: #409eff;
  line-height: 30px;
}

.web__main-item--mine {
  text-align: right;
  padding-left: 0;
  padding-right: 60px;
}

.web__main-item--mine .web__main-user {
  left: auto;
  right: 3px;
}

.web__main-item--mine .web__main-user cite {
  left: auto;
  right: 60px;
  text-align: right;
}

.web__main-item--mine .web__main-user cite i {
  padding-left: 0;
  padding-right: 15px;
}

.web__main-item--mine .web__main-text {
  margin-left: 0;

  text-align: left;
  background-color: #95ec69;
  color: #333334;
  border-radius: 10px;
  border: 1px solid #ececec;
}

.web__main-text img {
  max-width: 200px;
}
.web__main-text3 {
  background-color: #fff !important;
  color: #000 !important;
}

.readedMsg {
  color: #5a9cf8;
  @include change_size($font_size_normal);
}

.contextmenu__item {
  display: block;
  line-height: 34px;
  text-align: center;
}

.contextmenu__item:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.contextmenu {
  position: absolute;
  background-color: #fff;
  width: 100px;
  /*height: 106px;*/
  font-size: 12px;
  color: #444040;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  white-space: nowrap;
  z-index: 1000;
}

.contextmenu__item:hover {
  cursor: pointer;
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.web_main-systip {
  background-color: rgba(51, 51, 52, 0) !important;
  padding-left: 0;
  margin-left: 0;
  margin-top: 0;
}

.web__main-text1 {
  background-color: #c588ff;
  color: #ffffff;
}

.web__main-text2 {
  background-color: #ff7e7e;
  color: #ffffff;
}

.nick_container {
  @include change_size($font_size_normal);
  color: gray;
}
</style>
